import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Button,
  Container,
  Content,
  Header,
  Loader,
  CheckPicker,
  DatePicker,
} from "rsuite";
import { Form, Field, FormSpy } from "react-final-form";
import { render } from "react-dom";
import { ChartServices } from "../../../core/services/ChartServices";
import { HelperServices } from "../../../core/services/HelperServices";
import { StoreServices } from "../../../core/services/StoreServices";
import "./Chart.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { get } from "lodash/fp";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { useSelector } from "react-redux";
import CustomSelector from "../../shared/customSelector";
import { useTranslation } from "react-i18next";
import useDecryptedParams from "../../../navigation/useDecryptParams";
import {
  messageTypeArr,
  roleTypeArr,
  chartTypeObjArr,
  chartForObjArr,
  yesNoObjArr,
  chartAvailabilityObjArr,
  dateFormatObj,
} from "../../../core/config/AppConstants";
import { ValidatorCustom } from "./../../validators/ValidatorCustom";
import { ContentRoutes } from "../../../navigation/NavConstant";
import {
  addLabelValue,
  calenderDateToDB,
  dbDateToCalender,
  isEmptyVal,
  isNotEmpty,
  isNotNull,
} from "../../../utils/helpers";
import { ChartFields } from "./ChartDataTypes";
import moment from "moment";
function Chart() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [loader, setLoading] = useState(false);
  const [showEvent, setShowEvent] = useState<boolean>(false);
  const [showDate, setShowDate] = useState<boolean>(false);
  const [showCompanyType, setShowCompanyType] = useState<boolean>(false);
  const [showForAllComp, setShowForAllComp] = useState<boolean>(true);
  const [showStoreGroup, setShowStoreGroup] = useState<boolean>(false);
  const params: any = useParams();
  const company = useSelector((state: any) => state.company);
  const [file, setFile] = useState<any>();
  const [updateChartImage, setUpdateChartImage] = useState("");
  const [regionList, setRegionList] = useState([]);
  const [storeGroupList, setStoreGroupList] = useState([]);
  const [licenseList, setLicenseList] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [compTypeList, setCompTypeList] = useState([]);
  const [formData, setFormData] = useState<any>({
    name: "",
    company_id: "",
    region_id: "",
    license_id: "",
    store_group_id: "",
    event_id: "",
    max_songs: "",
    total_songs: "",
    for_company_types: "",
    chart_for: "master",
    for_all_company: "0",
    chart_type: "",
    availability: "always",
    start_date: "",
    end_date: "",
    status: "",
  });
  let [decryptedParams] = useDecryptedParams(params);

  async function init() {
    try {
      if (decryptedParams.id) {
        const response: any = await ChartServices.viewChart(
          +decryptedParams.id
        );
        const respData = get("data.data", response);
        const keyMapper: any = { name: "chart_title" };

        let obj = { ...formData };
        if (respData?.chart_image_url) {
          setUpdateChartImage(respData?.chart_image_url);
        }

        let keyMapperIndex = Object.keys(keyMapper);
        Object.keys(obj).map((formKeys) => {
          if (keyMapperIndex.includes(formKeys)) {
            obj[formKeys] = respData[keyMapper[formKeys]];
          } else if (formKeys === "start_date") {
            obj["start_date"] = isEmptyVal(respData["start_date"])
              ? null
              : dbDateToCalender(respData["start_date"]);
          } else if (formKeys === "end_date") {
            obj["end_date"] = isEmptyVal(respData["end_date"])
              ? null
              : dbDateToCalender(respData["end_date"]);
          } else if (formKeys === "status") {
            obj[formKeys] = respData?.status.toString();
          } else if (respData[formKeys]) {
            obj[formKeys] = respData[formKeys];
          }
        });
        setFormData({ ...obj });

        if (obj?.company_id) {
          getLicenseList(obj?.company_id);
          await getRegionList(obj?.company_id);
        }
        if (respData?.store_group?.region_id) {
          handleRegionChange(respData?.store_group?.region_id);
        }
        handleChartForChange(obj?.chart_for);
        handleChartTypeChange(obj?.chart_type);
        handleAvailabilityChange(obj?.availability);
      }
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      navigate(ContentRoutes.CHARTS);
    }
  }

  useEffect(() => {
    init();
  }, [decryptedParams.id]);

  useEffect(() => {
    getLicenseList();
    getEventList({});
    getCompTypeList({});
  }, []);

  useEffect(() => {
    getRegionList();
    getLicenseList();
  }, [company.id]);

  async function getCompTypeList(params: any) {
    try {
      setLoading(true);
      const res = await HelperServices.getCompanyTypes(params);

      const compTypesArr = addLabelValue(
        get("data.data", res),
        "type_name",
        "id"
      );
      setCompTypeList(compTypesArr);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  async function getEventList(params: any) {
    try {
      setLoading(true);
      const res = await HelperServices.getEvents(params);
      setEventList(get("data.data", res));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  async function getLicenseList(forComp?: number) {
    try {
      let compId: number = forComp ? forComp : getCompanyId();

      let params: any = {};
      if (compId) {
        params.company = compId;
      }
      setLoading(true);
      const res = await HelperServices.getAllValidLicenses(params);
      setLicenseList(get("data.data", res));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  async function getRegionList(forComp?: number) {
    let compId: number = forComp ? forComp : getCompanyId();
    setRegionList([]);
    if (!compId) {
      return;
    }
    let params: any = {};
    if (compId) {
      params.company = compId;
    }

    try {
      const res = await StoreServices.getRegions(params);
      const respData = get("data.data", res);
      if (respData.length) {
        setRegionList(respData);
      }
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  function resetChartFor() {
    setShowCompanyType(false);
    setShowForAllComp(false);
    setShowStoreGroup(false);
  }
  function handleChartForChange(chartFor?: string) {
    resetChartFor();
    if (chartFor == "master") {
      setShowForAllComp(true);
    } else if (chartFor == "public") {
      setShowCompanyType(true);
    } else if (chartFor == "company") {
      if (!decryptedParams.id && !getCompanyId()) {
        UtilityServices.showToaster({
          message: t("PLEASE_SELECT_FIELD", {
            field: t("COMPANY").toLowerCase(),
          }),
          type: messageTypeArr.warning,
        });
      }
      setShowStoreGroup(true);
    }
  }

  function handleChartTypeChange(chartType?: string) {
    setShowEvent(false);
    if (chartType == "event") {
      setShowEvent(true);
    }
  }

  function handleAvailabilityChange(availabilityType?: string) {
    setShowDate(false);
    if (availabilityType == "on-date") {
      setShowDate(true);
    }
  }

  async function handleRegionChange(regionId: number) {
    try {
      const res = await StoreServices.getStoreGroups({
        region: regionId,
      });
      const respData = get("data.data", res);
      setStoreGroupList(respData);
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  async function saveChart(form: any, id?: number) {
    try {
      setLoading(true);
      let response: any;
      if (id) {
        response = await ChartServices.updateChart(+id, form);
      } else {
        response = await ChartServices.createChart(form);
      }
      setLoading(false);
      UtilityServices.showToaster({
        message: response?.data?.message,
      });
      navigate(ContentRoutes.CHARTS);
    } catch (error: any) {
      setLoading(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setErrorMessage(error?.message);
    }
  }

  const handleDateChange = (date: any, frmIndex: any) => {
    let frmObj = { ...formData };
    frmObj[frmIndex as keyof typeof frmObj] = date;
    setFormData({ ...frmObj });
  };

  function getCompanyId() {
    let compId = null;
    if (UtilityServices.getLoggedInUser("user_type") === roleTypeArr.client) {
      compId = UtilityServices.getLoggedInUser("company_id");
    } else if (company?.id) {
      compId = company.id;
    }
    return compId;
  }

  const onSubmit = (val: any) => {
    const form = new FormData();
    for (var key in formData) {
      if (key == "start_date") {
        form.append("start_date", calenderDateToDB(val[key]));
      } else if (key == "end_date") {
        form.append("end_date", calenderDateToDB(val[key]));
      } else if (isNotNull(val[key])) {
        form.append(key, val[key]);
      }
    }
    if (file) {
      form.append("chart_image", file, file.name);
    }
    if (
      form.get("chart_for") == "company" &&
      !getCompanyId() &&
      !decryptedParams.id
    ) {
      UtilityServices.showToaster({
        message: t("PLEASE_SELECT_FIELD", {
          field: t("COMPANY").toLowerCase(),
        }),
        type: messageTypeArr.error,
      });
      return;
    }

    if (form.get("availability") == "always") {
      form.delete("start_date");
      form.delete("end_date");
    }

    if (decryptedParams.id) {
      saveChart(form, decryptedParams.id);
    } else {
      form.set("company_id", getCompanyId());
      saveChart(form);
    }
  };

  return (
    <div className="chart">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content="Loading..."
          center
          backdrop={true}
        />
      )}
      <Container className="container">
        <Header className="header mb-2">
          <h4>
            {decryptedParams.id ? t("UPDATE") : t("CREATE")} {t("CHART")}
          </h4>
        </Header>
        <Content className="content chart-create-wrap">
          <Form
            onSubmit={onSubmit}
            validate={(values: any) => {
              const errors: any = {};
              if (!values.name) {
                errors.name = t("REQUIRED", {
                  field: t("NAME").toLowerCase(),
                });
              }
              if (!values.chart_for) {
                errors.chart_for = t("REQUIRED", {
                  field:
                    t("CHART").toLowerCase() + " " + t("FOR").toLowerCase(),
                });
              }
              if (values.chart_for == "public" && !values.for_company_types) {
                errors.for_company_types = t("REQUIRED", {
                  field:
                    t("COMPANY").toLowerCase() + " " + t("TYPE").toLowerCase(),
                });
              }
              if (!values.license_id) {
                errors.license_id = t("REQUIRED", {
                  field: t("LICENSE").toLowerCase(),
                });
              }
              if (!values.chart_type) {
                errors.chart_type = t("REQUIRED", {
                  field:
                    t("CHART").toLowerCase() + " " + t("TYPE").toLowerCase(),
                });
              }
              if (values.chart_type == "event" && !values.event_id) {
                errors.event_id = t("REQUIRED", {
                  field:
                    t("EVENT").toLowerCase() + " " + t("TYPE").toLowerCase(),
                });
              }
              if (!values.max_songs || values.max_songs < 1) {
                errors.max_songs = t("REQUIRED", {
                  field:
                    t("MAX").toLowerCase() + " " + t("SONGS").toLowerCase(),
                });
              }
              if (!values.availability) {
                errors.availability = t("REQUIRED", {
                  field:
                    t("AVAILABILITY").toLowerCase() +
                    " " +
                    t("TYPE").toLowerCase(),
                });
              }
              if (values.availability == "on-date" && !values.start_date) {
                errors.start_date = t("REQUIRED", {
                  field:
                    t("START").toLowerCase() + " " + t("DATE").toLowerCase(),
                });
              }
              if (values.availability == "on-date" && !values.end_date) {
                errors.end_date = t("REQUIRED", {
                  field: t("END").toLowerCase() + " " + t("DATE").toLowerCase(),
                });
              }
              if (
                values.start_date &&
                values.end_date &&
                new Date(values.end_date) < new Date(values.start_date)
              ) {
                errors.end_date = t("DATE2_SHALL_BE_GREATER_THAN_EQUAL_DATE1", {
                  date2: t("END").toLowerCase() + " " + t("DATE").toLowerCase(),
                  date1:
                    t("START").toLowerCase() + " " + t("DATE").toLowerCase(),
                });
              }
              return errors;
            }}
            initialValues={{ ...formData }}
            render={({ handleSubmit, form }) => (
              <>
                <FormSpy
                  subscription={{ values: true }}
                  onChange={({ values }) => setFormData(values)}
                />
                <form onSubmit={handleSubmit}>
                  <Field name="image">
                    {({ input, meta }) => (
                      <div className="flex-item">
                        <div className="d-flex usr-img">
                          <div>
                            <img
                              className="usr-img-bx"
                              src={
                                file
                                  ? URL.createObjectURL(file)
                                  : updateChartImage
                                  ? updateChartImage
                                  : UtilityServices.getLoggedInUser(
                                      "chart_default_image"
                                    )
                              }
                              alt={t("CHART") + " " + t("IMAGE")}
                              title={t("CHART") + " " + t("IMAGE")}
                            />
                          </div>
                          <input
                            id="image-upload"
                            {...input}
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChangeCapture={(e: any) => {
                              setFile(e.target.files[0]);
                            }}
                            style={{ display: "none" }}
                          />
                          <label
                            className="chart-image-upload-lbl"
                            htmlFor="image-upload"
                          >
                            {t("UPLOAD")} {t("IMAGE")}
                          </label>
                        </div>
                      </div>
                    )}
                  </Field>
                  <div className="form-part">
                    <div className="flex-container">
                      <Field name="name">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <label>{t("NAME")}*</label>
                            <input {...input} type="text" required={true} />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="chart_for">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <CustomSelector
                              loaderMsg={null}
                              isRequired={true}
                              disabled={decryptedParams.id ? true : false}
                              valueKey="value"
                              labelKey="label"
                              labelName={t("CHART") + " " + t("FOR")}
                              defaultValue={input.value}
                              onClear={(event: any) => {
                                form.change("chart_for", "");
                                handleChartForChange();
                              }}
                              listData={chartForObjArr}
                              onSelect={(e: any, selectedObj: any) => {
                                form.change("chart_for", e);
                                handleChartForChange(e);
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      {showForAllComp && (
                        <Field name="for_all_company">
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <CustomSelector
                                loaderMsg={null}
                                isRequired={true}
                                valueKey="value"
                                labelKey="label"
                                labelName={
                                  t("FOR") + " " + t("ALL") + " " + t("COMPANY")
                                }
                                defaultValue={input.value}
                                onClear={(event: any) => {
                                  form.change("for_all_company", "0");
                                }}
                                listData={yesNoObjArr}
                                onSelect={(e: any, selectedObj: any) => {
                                  form.change("for_all_company", e);
                                }}
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>
                      )}
                      {showCompanyType && (
                        <Field name="for_company_types">
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <label>
                                {t("COMPANY")} {t("TYPE")}*
                              </label>
                              <CheckPicker
                                sticky
                                onChange={(e: any) => {
                                  let cTypes = e.filter(isNotEmpty);
                                  if (e.length) {
                                    form.change(
                                      "for_company_types",
                                      cTypes.toString()
                                    );
                                  } else {
                                    form.change("for_company_types", "");
                                  }
                                }}
                                onClean={() => {
                                  form.change("for_company_types", "");
                                }}
                                data={compTypeList}
                                value={input?.value?.toString().split(",")}
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>
                      )}
                      {showStoreGroup && (
                        <>
                          <Field name="region_id">
                            {({ input, meta }) => (
                              <div className="flex-item">
                                <CustomSelector
                                  loaderMsg={null}
                                  isRequired={false}
                                  valueKey="id"
                                  labelKey="region_name"
                                  isDisable={false}
                                  labelName={t("REGION")}
                                  defaultValue={input.value}
                                  onClear={(event: any) => {
                                    form.change("region_id", "");
                                    form.change("store_group_id", "");
                                    setStoreGroupList([]);
                                  }}
                                  listData={
                                    regionList?.length ? regionList : []
                                  }
                                  onSelect={(e: any, selectedObj: any) => {
                                    form.change("region_id", e);
                                    handleRegionChange(e);
                                  }}
                                />
                                {meta.error && meta.touched && (
                                  <span>{meta.error}</span>
                                )}
                              </div>
                            )}
                          </Field>
                          <Field name="store_group_id">
                            {({ input, meta }) => (
                              <div className="flex-item">
                                <CustomSelector
                                  loaderMsg={null}
                                  valueKey="id"
                                  labelKey="group_name"
                                  isRequired={false}
                                  isDisable={false}
                                  labelName={t("STORE") + " " + t("GROUP")}
                                  defaultValue={input.value}
                                  onClear={(event: any) => {
                                    form.change("store_group_id", "");
                                  }}
                                  listData={storeGroupList}
                                  onSelect={(e: any, selectedObj: any) => {
                                    form.change("store_group_id", e);
                                  }}
                                />
                                {meta.error && meta.touched && (
                                  <span>{meta.error}</span>
                                )}
                              </div>
                            )}
                          </Field>
                        </>
                      )}
                    </div>
                    <div className="flex-container">
                      <Field name="license_id">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <CustomSelector
                              loaderMsg={null}
                              isRequired={true}
                              valueKey="id"
                              labelKey="license_name"
                              labelName={t("LICENSE")}
                              defaultValue={input.value}
                              disabled={
                                decryptedParams.id && formData.total_songs > 0
                                  ? true
                                  : false
                              }
                              onClear={(event: any) => {
                                form.change("license_id", "");
                              }}
                              listData={licenseList}
                              onSelect={(e: any, selectedObj: any) => {
                                form.change("license_id", e);
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="chart_type">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <CustomSelector
                              loaderMsg={null}
                              isRequired={true}
                              valueKey="value"
                              labelKey="label"
                              labelName={t("CHART") + " " + t("TYPE")}
                              defaultValue={input.value}
                              onClear={(event: any) => {
                                form.change("chart_type", "");
                                handleChartTypeChange();
                              }}
                              listData={chartTypeObjArr}
                              onSelect={(e: any, selectedObj: any) => {
                                form.change("chart_type", e);
                                handleChartTypeChange(e);
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      {showEvent && (
                        <Field name="event_id">
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <CustomSelector
                                loaderMsg={null}
                                isRequired={true}
                                valueKey="id"
                                labelKey="event_name"
                                labelName={t("EVENT") + " " + t("NAME")}
                                defaultValue={input.value}
                                onClear={(event: any) => {
                                  form.change("event_id", "");
                                }}
                                listData={eventList}
                                onSelect={(e: any, selectedObj: any) => {
                                  form.change("event_id", e);
                                }}
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>
                      )}
                      <Field name="max_songs">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <label>
                              {t("MAX")} {t("SONGS")}*
                            </label>
                            <input
                              {...input}
                              type="number"
                              autoComplete="off"
                              min="1"
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                    </div>
                    <div className="flex-container">
                      <Field name="availability">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <CustomSelector
                              loaderMsg={null}
                              isRequired={true}
                              valueKey="value"
                              labelKey="label"
                              labelName={t("AVAILABILITY")}
                              defaultValue={input.value}
                              onClear={(event: any) => {
                                form.change("availability", "");
                                handleAvailabilityChange();
                              }}
                              listData={chartAvailabilityObjArr}
                              onSelect={(e: any, selectedObj: any) => {
                                form.change("availability", e);
                                handleAvailabilityChange(e);
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      {showDate && (
                        <>
                          <Field name="start_date">
                            {({ input, meta }) => (
                              <div className="flex-item">
                                <label>
                                  {t("START")} {t("DATE")}
                                </label>
                                <DatePicker
                                  value={input.value || null}
                                  defaultValue={formData?.start_date}
                                  format={dateFormatObj.calendar_d_m_y}
                                  name="start_date"
                                  id="start_date"
                                  onChange={(e: any) => {
                                    form.change("start_date", e);
                                    handleDateChange(e, "start_date");
                                    input.onChange(e);
                                  }}
                                  onClean={(event: any) => {
                                    form.change("start_date", "");
                                    handleDateChange("", "start_date");
                                    input.onChange("");
                                  }}
                                />
                                {meta.error && meta.touched && (
                                  <span>{meta.error}</span>
                                )}
                              </div>
                            )}
                          </Field>
                          <Field name="end_date">
                            {({ input, meta }) => (
                              <div className="flex-item">
                                <label>
                                  {t("END")} {t("DATE")}
                                </label>
                                <DatePicker
                                  value={input.value || null}
                                  defaultValue={formData?.end_date}
                                  format={dateFormatObj.calendar_d_m_y}
                                  name="end_date"
                                  id="end_date"
                                  onChange={(e: any) => {
                                    form.change("end_date", e);
                                    handleDateChange(e, "end_date");
                                    input.onChange(e);
                                  }}
                                  onClean={(event: any) => {
                                    form.change("end_date", "");
                                    handleDateChange("", "end_date");
                                    input.onChange("");
                                  }}
                                />
                                {meta.error && meta.touched && (
                                  <span>{meta.error}</span>
                                )}
                              </div>
                            )}
                          </Field>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="create-action d-flex flex-end">
                    <Link to={ContentRoutes.CHARTS}>
                      <Button appearance="primary" color="red" type="button">
                        {t("CANCEL")}
                      </Button>
                    </Link>
                    <Button appearance="primary" color="green" type="submit">
                      {decryptedParams.id ? t("UPDATE") : t("CREATE")}
                    </Button>
                    <Button
                      appearance="default"
                      type="reset"
                      onClick={() => {
                        // review comment: move to new function
                        form.reset();
                        setFile("");
                        setUpdateChartImage("");
                        if (form.getState().values.region_id) {
                          handleRegionChange(form.getState().values.region_id);
                        }
                      }}
                    >
                      {t("RESET")}
                    </Button>
                  </div>
                </form>
              </>
            )}
          />
        </Content>
      </Container>
    </div>
  );
}

export default Chart;
